import styled from 'styled-components';
import { CellWrapper } from '../../columns/styled';

export const ActionsCellWrapper = styled(CellWrapper)`
    justify-content: flex-start;
    padding: 0 2rem 0 0;
    gap: 1.75rem;
`;
